export default __webpack_public_path__ + "static/media/image2.e46e9246.png";